/**
 * Spinner — replaces the ad-hoc loading-spinner / border-spinner patterns
 * scattered across the app. Always uses semantic tokens so it reads
 * correctly in light + dark.
 *
 * Usage:
 *   <Spinner />                        // md, brand-colored
 *   <Spinner size="sm" tone="inverse"/>// for use inside dark CTAs
 *   <Spinner label="Loading…" />       // accessible label
 */

const SIZES = {
  xs: 'w-3 h-3 border-2',
  sm: 'w-4 h-4 border-2',
  md: 'w-6 h-6 border-2',
  lg: 'w-8 h-8 border-[3px]',
  xl: 'w-12 h-12 border-4',
}

const TONES = {
  brand:   'border-brand/30 border-t-brand',
  inverse: 'border-white/40 border-t-white',
  muted:   'border-ink-muted/30 border-t-ink-muted',
  current: 'border-current/30 border-t-current',
}

export default function Spinner({ size = 'md', tone = 'brand', className = '', label }) {
  return (
    <span
      role="status"
      aria-live="polite"
      aria-label={label || 'Loading'}
      className={`inline-block rounded-full animate-spin ${SIZES[size] || SIZES.md} ${TONES[tone] || TONES.brand} ${className}`}
    />
  )
}
